<div class="stackholder-chart-wrapper">
  @if (loading) {
  <div class="chart-state" aria-live="polite" aria-busy="true">
    <div class="spinner"></div>
    <div class="loader-text">Loading chart...</div>
  </div>
  } @if (!loading && chartData.length === 0) {
  <div class="no-data">
    No data available.
  </div>
  }

  <!-- Tooltip — rendered by Angular so it is never affected by SVG stacking -->
  @if (tooltipVisible) {
  <div class="stack-chart-tooltip">
    <div class="sct-month">{{ tooltipMonth }}</div>
    @for (item of tooltipItems; track item) {
    <div class="sct-row" [class.sct-row--current]="item.isCurrent">
      <span class="sct-swatch" [style.background]="item.color"></span>
      <span class="sct-key">{{ item.key }}</span>
      <span class="sct-val">{{ item.value }}</span>
    </div>
    }
  </div>
  }

  <!-- Chart canvas — always in DOM so ViewChild reference is available -->
  <div #stackChartContainer class="stack-chart-canvas"></div>

  <!-- Legend — below the chart, centre-aligned -->
  @if (!loading && legendItems.length > 0) {
  <div class="stack-legend">
    @for (item of legendItems; track item) {
    <div class="stack-legend-item">
      <span class="stack-legend-swatch" [style.background]="item.backgroundColor"></span>
      <span class="stack-legend-label">{{ item.key }}</span>
    </div>
    }
  </div>
  }
</div>
